"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStagedChangesCount = exports.getCompanyCountry = exports.getCompanyZip = exports.getCompanyState = exports.getCompanyCity = exports.getCompanyAddressLine2 = exports.getCompanyAddressLine1 = exports.getCompanyDomain = exports.getStagedCompanyName = exports.getAccent2Color = exports.getAccentColor = exports.getSecondaryColor = exports.getPrimaryColor = exports.getCompanyAvatar = exports.getCompanyLogoAltText = exports.getCompanyLogoUrl = exports.getCompanyAddress = exports.getCompanyName = exports.getMergedBranding = exports.getStagedChanges = exports.getBranding = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("transmute/get"));

var _constants = require("./constants");

var getBrandingState = function getBrandingState(state) {
  return state.modules['account-defaults'].branding;
};

var getBranding = (0, _reselect.createSelector)([getBrandingState], function (branding) {
  return (0, _get.default)('data', branding);
});
exports.getBranding = getBranding;
var getStagedChanges = (0, _reselect.createSelector)([getBrandingState], function (branding) {
  return (0, _get.default)('staged', branding);
});
exports.getStagedChanges = getStagedChanges;
var getMergedBranding = (0, _reselect.createSelector)([getBranding, getStagedChanges], function (currentBranding, stagedBranding) {
  return currentBranding.merge(stagedBranding);
});
exports.getMergedBranding = getMergedBranding;
var getCompanyName = (0, _reselect.createSelector)([getBrandingState], function (branding) {
  return (0, _get.default)(_constants.COMPANY_NAME, branding);
});
exports.getCompanyName = getCompanyName;
var getCompanyAddress = (0, _reselect.createSelector)([getBrandingState], function (branding) {
  return (0, _get.default)(_constants.COMPANY_ADDRESS, branding);
});
exports.getCompanyAddress = getCompanyAddress;
var getCompanyLogoUrl = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_LOGO_URL, stagedBranding);
});
exports.getCompanyLogoUrl = getCompanyLogoUrl;
var getCompanyLogoAltText = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_LOGO_ALT_TEXT, stagedBranding);
});
exports.getCompanyLogoAltText = getCompanyLogoAltText;
var getCompanyAvatar = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_AVATAR, stagedBranding);
});
exports.getCompanyAvatar = getCompanyAvatar;
var getPrimaryColor = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.PRIMARY_COLOR, stagedBranding);
});
exports.getPrimaryColor = getPrimaryColor;
var getSecondaryColor = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.SECONDARY_COLOR, stagedBranding);
});
exports.getSecondaryColor = getSecondaryColor;
var getAccentColor = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.ACCENT_COLOR, stagedBranding);
});
exports.getAccentColor = getAccentColor;
var getAccent2Color = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.ACCENT2_COLOR, stagedBranding);
});
exports.getAccent2Color = getAccent2Color;
var getStagedCompanyName = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_NAME, stagedBranding);
});
exports.getStagedCompanyName = getStagedCompanyName;
var getCompanyDomain = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_DOMAIN, stagedBranding);
});
exports.getCompanyDomain = getCompanyDomain;
var getCompanyAddressLine1 = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_ADDRESS_LINE1, stagedBranding);
});
exports.getCompanyAddressLine1 = getCompanyAddressLine1;
var getCompanyAddressLine2 = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_ADDRESS_LINE2, stagedBranding);
});
exports.getCompanyAddressLine2 = getCompanyAddressLine2;
var getCompanyCity = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_CITY, stagedBranding);
});
exports.getCompanyCity = getCompanyCity;
var getCompanyState = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_STATE, stagedBranding);
});
exports.getCompanyState = getCompanyState;
var getCompanyZip = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_ZIP, stagedBranding);
});
exports.getCompanyZip = getCompanyZip;
var getCompanyCountry = (0, _reselect.createSelector)([getStagedChanges], function (stagedBranding) {
  return (0, _get.default)(_constants.COMPANY_COUNTRY, stagedBranding);
});
exports.getCompanyCountry = getCompanyCountry;
var getStagedChangesCount = (0, _reselect.createSelector)([getBranding, getStagedChanges], function (branding, stagedBranding) {
  return branding.reduce(function (acc, val, key) {
    if (stagedBranding.get(key) !== val) {
      return acc + 1;
    }

    return acc;
  }, 0);
});
exports.getStagedChangesCount = getStagedChangesCount;